module.exports = __webpack_public_path__ + "static/media/riskit.e4c13a08.png";